import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=5c1acae4&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppMain.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=5c1acae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1acae4",
  null
  
)

export default component.exports